import { Component, Input } from '@angular/core';
import { PotentialMismatchedDpsFingerprintAssociationDto } from '../services/api.service';

@Component({
  selector: 'cert-mismatched-fingerprint-association-popover',
  templateUrl: './mismatched-fingerprint-association-popover.component.html',
  styles: ``,
  standalone: false,
})
export class MismatchedFingerprintAssociationPopoverComponent {
  @Input() potentialMismatchedFingerprintAssociation?: PotentialMismatchedDpsFingerprintAssociationDto | undefined;
  @Input() makeLarge = false;
}
